export const adhesionContractTypes = {
  PADRAO: "Padrão",
  PERSONALIZADO: "Personalizado"
};